import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

interface IProps {
  size?: 'small' | 'medium' | 'large';
  loading?: boolean;
  fullscreen?: boolean;
  children?: React.ReactNode;
}

export const SharedSpinner: React.FC<IProps> = ({
  size = 'medium',
  loading,
  fullscreen,
  children,
}) => {
  // The indicator follows the size - small is for inline spots (a chip row, a list footer), where 24px
  // is a lot.
  const px = size === 'small' ? 16 : size === 'large' ? 32 : 24;
  return (
    <Spin
      size={size}
      spinning={loading}
      description={children || fullscreen ? 'Loading...' : undefined}
      fullscreen={fullscreen}
      indicator={<LoadingOutlined style={{ fontSize: px }} spin />}
    >
      {children}
    </Spin>
  );
};
